import { CancelTokenSource } from 'axios'
import AnonymousAgent from '../api/AnonymousAgent'
import { IQuizAnswerRequest } from '../models/WorkplaceQuiz'

class WorkplaceQuizService {
  getQuizModules = async (source?: CancelTokenSource) => {
    return AnonymousAgent.WorkplaceQuiz.getModules(source)
  }

  getQuizModule = async (id: number, source?: CancelTokenSource) => {
    return AnonymousAgent.WorkplaceQuiz.getModule(id, source)
  }

  checkAnswer = async (
    request: IQuizAnswerRequest,
    source?: CancelTokenSource
  ) => {
    return AnonymousAgent.WorkplaceQuiz.checkAnswer(request, source)
  }
}

export default new WorkplaceQuizService()
